import classnames from 'classnames'
import React, { useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import FavoriteIcon from '@material-symbols/svg-300/rounded/favorite-fill.svg'
import FavoriteBorderIcon from '@material-symbols/svg-300/rounded/favorite.svg'

import { LearningItem } from '../../models/LearningItem'
import useSetFavorite from '../../state/mutations/useSetFavorite'
import useDialog from '../../utilities/useDialog'
import Button from '../basics/Button/Button'
import ConfirmDialog from '../basics/ConfirmDialog/ConfirmDialog'

import styles from './FavoriteBadge.module.scss'

export default React.memo(function FavoriteBadge({ course, className }: { course: LearningItem; className?: string }) {
  const { t } = useTranslation()
  const showDialog = useDialog()

  const setFavorite = useSetFavorite()

  const handleClick = useCallback(async () => {
    if (
      course.isFavorite &&
      !(await showDialog((close) => (
        <ConfirmDialog close={close} yesLabel={t('generic cta.remove')} noLabel={t('generic cta.cancel')}>
          <p>
            <Trans t={t} i18nKey="browse courses.should learning item <title> be removed from favorites">
              {{ title: course.title }}
            </Trans>
          </p>
        </ConfirmDialog>
      )))
    ) {
      return
    }
    setFavorite.mutate(course.uuid)
  }, [course, setFavorite, showDialog, t])

  return (
    <Button small plain onClick={handleClick} className={classnames(styles.FavoriteBadge, className)}>
      {course.isFavorite ? <FavoriteIcon /> : <FavoriteBorderIcon />}
    </Button>
  )
})
